import { SkipButton, useSkipButton } from '../common/SkipButton'
import { ViewProps } from '../types'

export function ReviewSkipButton(props: ViewProps) {
  const skipButtonState = useSkipButton(props)
  return <SkipButton {...skipButtonState} />
}
